module.exports = __webpack_public_path__ + "static/img/brand-fourth-2.0274d65b.png";